<template>
  <div id="app" ref="app">
    <Header v-if="!isMobile" />
    <MHeader v-else />
    <div :class="isMobile ? 'router-view mobile-view' : 'router-view'">
      <router-view />
    </div>
    <Footer v-if="!isMobile" />
    <MFooter v-else />
  </div>
</template>
<script>
import axios from 'axios'
import {domain} from '@/utils/domain'
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
import MHeader from "./components/mHeader.vue";
import MFooter from "./components/mFooter.vue";
import("./assets/styles/index.scss");
export default {
  name: "App",
  components: {
    Footer,
    Header,
    MHeader,
    MFooter,
  },
  data() {
    return {
      showMobile: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|Macintosh|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
  },
  created() {
    this.getConfigIp()
    this.checkWidth()
  },
  mounted() {
    window.addEventListener("resize", this.checkWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkWidth);
  },
  methods: {
    getConfigIp() {
      axios.get(`/template/ip.json`).then(res => {
        domain.Base_URL = res.data.ip
        domain.Base_M1_URL = res.data.ip
        domain.Base_M2_URL = res.data.ip
        localStorage.setItem('__dsc_ip', res.data.ip)
      })
    },
    checkWidth() {
      let isMobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|Macintosh|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      var pathAndQuery = window.location.pathname + window.location.search;
      if (isMobile) {
        console.log('MOBILE')
        if (window.location.href.indexOf("/m") == -1) {
          if (pathAndQuery == "/") {
            window.location.href = window.location.href.replace(
              window.location.origin,
              window.location.origin + "/m"
            );
          } else {
            window.location.href = window.location.href.replace(
              window.location.origin + "/",
              window.location.origin + "/m-"
            );
          }
        }
      } else {
        console.log('PC')
        if (window.location.href.indexOf("/m") != -1) {
          if (pathAndQuery.indexOf("/m-") != -1) {
            window.location.href = window.location.href.replace(
              window.location.origin + "/m-",
              window.location.origin + "/"
            );
          } else if (pathAndQuery == "/m") {
            window.location.href = window.location.href.replace(
              window.location.origin + "/m",
              window.location.origin + "/"
            );
          } else {
            window.location.href = window.location.href.replace(
              window.location.origin + "/m",
              window.location.origin
            );
          }
        }
      }
    },
  },
};
</script>

<style lang="less">
#app{
  overflow: hidden;
}
.router-view {
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(180deg, #FFFFFF 0%, #EBF3FE 100%);
}
.mobile-view {
  overflow: hidden;
}
</style>
